/* global axios */

import ApiClient from './ApiClient';

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  // Filtros vazios não vão na query — o backend trata ausência como "sem filtro".
  get({ page, userId, category, query } = {}) {
    const params = {};
    if (page) params.page = page;
    if (query) params.q = query;
    if (userId) params.user_id = userId;
    if (category) params.category = category;
    return axios.get(this.url, { params });
  }
}

export default new AuditLogs();
